export default {
    appAdapters: {
        adapters: ['amazon', 'etsy', 'ebay', 'shopify', 'quickbooks']
    }
}
